export const nav_home = "Inicio";
export const nav_about = "Sobre Nosotros";
export const nav_services = "Servicios";
export const nav_gallery = "Trabajos";
export const nav_contact = "Contacto";

export const hero_badge = "SOLDADURA PROFESIONAL";
export const hero_title_1 = "Uniendo calidad y Precisión,";
export const hero_title_2 = "soldamos";
export const hero_title_3 = "tus proyectos";
export const hero_title_4 = "con excelencia";
export const hero_subtitle = "Expertos en Soldadura Industrial y Fabricación de Metal con más de 15 años de experiencia";
export const hero_btn_gallery = "VER TRABAJOS";
export const hero_btn_quote = "Solicita tu Cotización";

export const about_label = "NUESTRA HISTORIA";
export const about_title = "Quiénes Somos";
export const about_text_1 = "AbrilWeldWorksPro LLC es una empresa líder en soldadura industrial y fabricación de metal, con más de 15 años de experiencia en el sector. Nos especializamos en ofrecer soluciones de alta calidad para proyectos industriales, comerciales y residenciales.";
export const about_text_2 = "Nuestro compromiso es brindar servicios excepcionales con los más altos estándares de calidad, seguridad y precisión. Cada proyecto es único y nos dedicamos a superar las expectativas de nuestros clientes con trabajo artesanal y profesional.";
export const about_stat_1 = "Años de Experiencia";
export const about_stat_2 = "Proyectos Completados";
export const about_stat_3 = "Satisfacción Cliente";

export const services_title = "Nuestros Servicios";
export const services_subtitle = "Ofrecemos una amplia gama de servicios de soldadura y fabricación de metal para satisfacer todas tus necesidades";
export const service_1_title = "Soldadura MIG";
export const service_1_desc = "Soldadura de alta precisión con tecnología MIG y TIG para trabajos industriales y comerciales de máxima calidad.";
export const service_2_title = "Fabricación de Estructuras Metálicas";
export const service_2_desc = "Diseño y construcción de estructuras metálicas personalizadas para proyectos industriales, comerciales y residenciales.";
export const service_3_title = "Reparación y Mantenimiento Industrial";
export const service_3_desc = "Servicios especializados de reparación y mantenimiento preventivo para equipos y estructuras metálicas industriales.";
export const service_btn_more = "MÁS INFO";
export const service_available = "Consulta disponible";

export const gallery_title = "Nuestros Trabajos";
export const gallery_subtitle = "Explora algunos de nuestros proyectos más destacados";
export const gallery_btn_all = "VER TODOS LOS TRABAJOS";

export const contact_title = "Contáctanos";
export const contact_subtitle = "Estamos aquí para ayudarte con tu próximo proyecto";
export const contact_phone = "Teléfono";
export const contact_email = "Email";
export const contact_address = "Dirección";
export const contact_hours = "Horario";
export const contact_hours_value = "Lun - Vie: 8:00 AM - 6:00 PM";
export const contact_qr_title = "Escanea para Contactar por WhatsApp";
export const contact_spanish = "Español";
export const contact_english = "English";

export const footer_tagline = "Soldadura profesional de calidad superior";
export const footer_quick_links = "Enlaces Rápidos";
export const footer_services_title = "Servicios";
export const footer_contact_title = "Contacto";
export const footer_rights = "Todos los derechos reservados.";
export const footer_powered = "Powered by Readdy";

export const modal_language_title = "¿En qué idioma prefieres la atención?";
export const modal_language_subtitle = "Selecciona tu idioma preferido para continuar";
export const modal_cancel = "Cancelar";

export default {
  nav_home,
  nav_about,
  nav_services,
  nav_gallery,
  nav_contact,
  hero_badge,
  hero_title_1,
  hero_title_2,
  hero_title_3,
  hero_title_4,
  hero_subtitle,
  hero_btn_gallery,
  hero_btn_quote,
  about_label,
  about_title,
  about_text_1,
  about_text_2,
  about_stat_1,
  about_stat_2,
  about_stat_3,
  services_title,
  services_subtitle,
  service_1_title,
  service_1_desc,
  service_2_title,
  service_2_desc,
  service_3_title,
  service_3_desc,
  service_btn_more,
  service_available,
  gallery_title,
  gallery_subtitle,
  gallery_btn_all,
  contact_title,
  contact_subtitle,
  contact_phone,
  contact_email,
  contact_address,
  contact_hours,
  contact_hours_value,
  contact_qr_title,
  contact_spanish,
  contact_english,
  footer_tagline,
  footer_quick_links,
  footer_services_title,
  footer_contact_title,
  footer_rights,
  footer_powered,
  modal_language_title,
  modal_language_subtitle,
  modal_cancel
};